export * from "./palette.js";
export * from "./radius.js";
export * from "./semantic-theme.js";
export * from "./spacing.js";
export * from "./typography.js";

import { palette } from "./palette.js";
import { radius } from "./radius.js";
import {
  directionBWarmth,
  semanticLayout,
  semanticTheme,
} from "./semantic-theme.js";
import { spacing } from "./spacing.js";
import { typography } from "./typography.js";

export const designTokens = {
  palette,
  directionBWarmth,
  semanticLayout,
  semanticTheme,
  radius,
  spacing,
  typography,
} as const;
